import api from "../../service/api";
import { widget } from "@/lib/charting_library.min.js";
import config from "@/components/Common/tradingView/config";
import DataFeeds from "@/components/Common/tradingView/datafeed.js";
import { SpecialTreatment } from "@/tools/filter";
import ConfigureInfo from "@/connect/configureInfo";

const checkTime = (sup) => {
  if (sup >= 10) return sup;

  return `0${sup}`;
};

export default {
  namespaced: true,
  state: () => ({
    totalKlines: [],
    finishKlines: () => {
      console.log("finishKlines");
    },
    widgetTVOk: true,
    widgetTV: null,
    containerId: "k-line",
    onRealTimeCallback: null,
    data: [],
    lineListActive: {
      name: "Candles",
      value: 1,
      icon: "icon-candles_normal",
      iconActive: "icon-candles_select",
    },
    lineList: [
      {
        name: "Candles",
        value: 1,
        icon: "icon-candles_normal",
        iconActive: "icon-candles_select",
      },
      {
        name: "Bars",
        value: 0,
        icon: "icon-bars_normal",
        iconActive: "icon-bars_select",
      },
      {
        name: "Line",
        value: 2,
        icon: "icon-line_normal",
        iconActive: "icon-line_select",
      },
      {
        name: "Area",
        value: 3,
        icon: "icon-area_normal",
        iconActive: "icon-area_select",
      },
      {
        name: "Heiken Ashi",
        value: 8,
        icon: "icon-heikin-ashi_normal",
        iconActive: "icon-heikin-ashi_select",
      },
      {
        name: "Hollow Candles",
        value: 9,
        icon: "icon-hollow-candles_normal",
        iconActive: "icon-hollow-candles_select",
      },
    ],
    timeList: [
      {
        name: "Time",
        interval: "1",
        apiInterval: "1",
        active: "1m-line",
        chartType: 3,
        timeLen: 1,
      },
      {
        name: "Min",
        type: "min",
        child: [
          {
            name: "1 Min",
            interval: "1",
            apiInterval: "1",
            type: "min",
            active: "1m-candle",
            chartType: 1,
            timeLen: 1,
          },
          {
            name: "5 Min",
            interval: "5",
            apiInterval: `2`,
            type: "min",
            active: "5m-candle",
            chartType: 1,
            timeLen: 5,
          },
          {
            name: "15 Min",
            interval: "15",
            apiInterval: `3`,
            type: "min",
            active: "15m-candle",
            chartType: 1,
            timeLen: 15,
          },
          {
            name: "30 Min",
            interval: "30",
            apiInterval: `4`,
            type: "min",
            active: "30m-candle",
            chartType: 1,
            timeLen: 30,
          },
        ],
      },
      {
        name: "Hour",
        type: "hour",
        child: [
          {
            name: "1 Hour",
            interval: "60",
            apiInterval: `5`,
            type: "hour",
            active: "1h-candle",
            chartType: 1,
            timeLen: 60,
          },
          {
            name: "4 Hour",
            interval: "240",
            apiInterval: `6`,
            type: "hour",
            active: "4h-candle",
            chartType: 1,
            timeLen: 4 * 60,
          },
        ],
      },
      {
        name: "1D",
        interval: "1D",
        apiInterval: `7`,
        active: "1d-candle",
        chartType: 1,
        timeLen: 24 * 60,
      },
      {
        name: "1W",
        interval: "1W",
        apiInterval: `8`,
        active: "1w-candle",
        chartType: 1,
      },
      {
        name: "1M",
        interval: "1M",
        apiInterval: `9`,
        active: "1M-candle",
        chartType: 1,
      },
    ],
    timeListActive: {
      name: "15 Min",
      interval: "15",
      apiInterval: `3`,
      type: "min",
      active: "15m-candle",
      chartType: 1,
      timeLen: 15,
    },
    marketTypeActive: {
      name: "Pre-Adjustment",
      value: 2,
    },
    marketTypeList: [
      {
        name: "Pre-Adjustment",
        value: 2,
      },
      {
        name: "Unadjusted",
        value: 1,
      },
    ],
    height: 0,
    getKLinePair: "",
    getKLineNoData: false,
    async getKLineFunc(endTime, concat = false) {
      const limit = 1000;

      const data = await api["queryLineInfo"]({
        pair: this.getKLinePair,
        endTime,
        limit,
        type: this.timeListActive.apiInterval,
        adjustedType: this.marketTypeActive.value,
      });

      this.getKLineNoData = data.queryLineDetails.length < limit;

      const rewriteData = data.queryLineDetails.map((ele) => ({
        time: ele.lineTime,
        open: Number(ele.open),
        high: Number(ele.high),
        low: Number(ele.low),
        close: Number(ele.close),
        volume: Number(ele.volume),
      }));

      if (concat) {
        this.data = rewriteData.concat(this.data);
      } else {
        this.data = rewriteData;

        this.height = data.blockHeight;
      }
    },
  }),
  getters: {},
  mutations: {
    SET_MARKET_TYPE_ACTIVE(state, data) {
      state.marketTypeActive = data;
    },
    SET_WIDGET_OK(state, data) {
      state.widgetTVOk = data;
    },
    SET_LINE_DATA(state, data) {
      state.data = data.map((ele) => ({
        time: ele.lineTime,
        open: Number(ele.open),
        high: Number(ele.high),
        low: Number(ele.low),
        close: Number(ele.close),
        volume: Number(ele.volume),
      }));
    },

    SET_WIDGET_TV(state, data) {
      state.widgetTV = data;
    },

    SET_TIME_ACTIVE(state, data) {
      state.timeListActive = data;
    },

    UPDATE_HEIGHT(state, height) {
      state.height = height;
    },
    SET_PAIR(state, pair) {
      state.getKLinePair = pair;
    },
    SET_LINE_ACTIVE(state, data) {
      state.lineListActive = data;

      state.widgetTV.chart().setChartType(data.value);
    },
  },
  actions: {
    marketTypeActiveHandle({ commit, dispatch }, data) {
      commit("SET_MARKET_TYPE_ACTIVE", data);
      dispatch("getInfo");
    },
    async getKLine({ commit, state, rootState }, opt) {
      console.log(opt);

      commit("SET_PAIR", rootState.tradingPair.queryPairInfo.pair);

      await state.getKLineFunc(0);
    },

    updateKLine({ commit, state }, opt) {
      // opt.forEach((ele) => {
      commit("UPDATE_HEIGHT", opt.blockHeight);
      state.onRealTimeCallback({
        time: opt.lineTime,
        open: Number(opt.open),
        high: Number(opt.high),
        low: Number(opt.low),
        close: Number(opt.close),
        volume: Number(opt.volume),
      });
      // });
    },

    /**
     * subscription
     */
    async subscribe({ rootState, state }) {
      await rootState.ws.websocketsend({
        type: "subscribe",
        channel: "line",
        id: `${state.timeListActive.apiInterval}@${rootState.tradingPair.queryPairInfo.pair}`,
        last_height: state.height,
        chainId: ConfigureInfo.Marginx.chainId,
      });
    },

    async unsubscribe({ rootState, state }) {
      await rootState.ws.websocketsend({
        type: "unsubscribe",
        channel: "line",
        id: `${state.timeListActive.apiInterval}@${rootState.tradingPair.queryPairInfo.pair}`,
        chainId: ConfigureInfo.Marginx.chainId,
      });
    },

    async widgetTV({ commit, rootState, state }) {
      await commit(
        "SET_WIDGET_TV",
        new widget({
          debug: false,
          symbol: SpecialTreatment.setPair(
            rootState.tradingPair.queryPairInfo.pair.toUpperCase()
          ),
          timezone: "Asia/Shanghai",
          fullscreen: false,
          interval: state.timeListActive.interval,
          container_id: state.containerId,
          library_path: "/charting_library/",
          locale: "en",
          autosize: true,
          datafeed: new DataFeeds(
            state,
            rootState.tradingPair.queryPairInfo.pair,
            state.timeListActive.apiInterval,
            rootState.tradingPair.queryPairInfo.pricePrecision
          ),
          theme: "Dark",
          toolbar_bg: "#101314",
          precision: 3,
          drawings_access: {
            type: "black",
            tools: [{ name: "Regression Trend" }],
          },
          customFormatters: {
            timeFormatter: {
              format: (date) => {
                const _format_str = "%h:%m:%s";
                return _format_str
                  .replace("%h", checkTime(date.getUTCHours()), 2)
                  .replace("%m", checkTime(date.getUTCMinutes()), 2)
                  .replace("%s", checkTime(date.getUTCSeconds()), 2);
              },
            },
            dateFormatter: {
              format: (date) => {
                const format = "YYYY-MM-DD";

                return format
                  .replace("YYYY", date.getUTCFullYear(), 2)
                  .replace("MM", checkTime(date.getUTCMonth() + 1), 2)
                  .replace("DD", checkTime(date.getUTCDate()), 2);
              },
            },
          },
          ...config,
        })
      );
    },

    async getInfo({ dispatch, state, commit }, opt) {
      commit("SET_WIDGET_OK", true);
      console.log(opt);
      await dispatch("getKLine", opt);
      await dispatch("widgetTV");
      state.widgetTV.onChartReady(() => {
        dispatch("subscribe");

        commit("SET_WIDGET_OK", false);

        commit("SET_LINE_ACTIVE", state.lineListActive);

        state.widgetTV
          .chart()
          .createStudy("Moving Average", false, false, [7], null, {
            "Plot.color": "rgb(150, 95, 196)",
          });

        state.widgetTV
          .chart()
          .createStudy("Moving Average", false, false, [25], null, {
            "Plot.color": "rgb(116,149,187)",
          });

        state.widgetTV
          .chart()
          .createStudy("Moving Average", false, false, [99], null, {
            "Plot.color": "rgb(58,113,74)",
          });
      });
    },

    async updateLineActive({ commit }, data) {
      commit("SET_LINE_ACTIVE", data);
    },

    async updateTimeActive({ commit, dispatch }, data) {
      await dispatch("unsubscribe");

      commit("SET_TIME_ACTIVE", data);
    },
  },
};
